import React, { Component } from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="footer-copyright fixed-bottom text-center py-3 sinclairRed mt-5">
        <MDBContainer fluid>
          &copy; {new Date().getFullYear()}
          <a
            href="http://www.sinclair.edu/"
            target="_blank"
            className="ml-2 mr-2"
          >
            Sinclair College
          </a>
          {""}|
          <a
            href="http://www.sinclair.edu/about/consumer-info/privacy-statement/"
            target="_blank"
            className="ml-2 mr-2"
          >
            Privacy Policy
          </a>
          |
          <a
            href="http://it.sinclair.edu/index.cfm/services/student-and-guests-services/policies-and-security-information/information-security-policy/?_ga=2.79722128.667250879.1550589582-452920039.1550589582"
            target="_blank"
            className="ml-2 mr-2"
          >
            Security Policy
          </a>
          |
          <a
            href="http://www.sinclair.edu/accessibility"
            target="_blank"
            className="ml-2 mr-2"
          >
            Accessibility
          </a>
        </MDBContainer>
      </div>
    );
  }
}

export default Footer;
